import { render, staticRenderFns } from "./ReporteGestionVentas.vue?vue&type=template&id=0522af9e&scoped=true"
import script from "./ReporteGestionVentas.vue?vue&type=script&lang=js"
export * from "./ReporteGestionVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522af9e",
  null
  
)

export default component.exports